import React, {
	useEffect,
	createContext,
	useContext,
	useState,
	ReactNode,
} from "react";

// Define the shape of your state

// Define the context type
interface TimerContextType {
	timeLeft: number;
	setTimeLeft: React.Dispatch<React.SetStateAction<number>>;
	isTimeUp: boolean;
	setIsTimeUp: React.Dispatch<React.SetStateAction<boolean>>;
	isPaused: boolean;
	setIsPaused: React.Dispatch<React.SetStateAction<boolean>>;
	formatTime: (seconds: number) => string;
}

// Create the context
const TimerContext = createContext<TimerContextType | undefined>(undefined);

// Context Provider component
export const TimerProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [timeLeft, setTimeLeft] = useState(60);
	const [isTimeUp, setIsTimeUp] = useState(false);
	const [isPaused, setIsPaused] = useState(false);
	useEffect(() => {
		if (isPaused) return;
		if (timeLeft === 0) {
			setIsTimeUp(true);
			return;
		}
		const timerId = setInterval(() => {
			setTimeLeft((prevTime) => prevTime - 1);
		}, 1000);

		return () => clearInterval(timerId); // Cleanup interval on component unmount
	}, [isPaused, timeLeft]);

	const formatTime = (seconds: number) => {
		const minutes = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${minutes.toString().padStart(2, "0")}:${secs
			.toString()
			.padStart(2, "0")}`;
	};
	return (
		<TimerContext.Provider
			value={{
				timeLeft,
				setTimeLeft,
				isTimeUp,
				setIsTimeUp,
				isPaused,
				setIsPaused,
				formatTime,
			}}
		>
			{children}
		</TimerContext.Provider>
	);
};

// Custom hook to use the context
export const useTimerContext = (): TimerContextType => {
	const context = useContext(TimerContext);
	if (!context) {
		throw new Error(
			"useQuestionContext must be used within a QuestionProvider"
		);
	}
	return context;
};
